import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SectionHeader from '../Basic/SectionHeader';
import Radio from '../Basic/Radio';

class RadioSection extends React.Component {
    componentWillReceiveProps(props) {
        if (props.error)
            this.setState({ error: props.error });
        else
            this.setState({ error: null });
    }
    change(e) {
        this.props.dispatch({ type: 'radio', name: this.props.name, value: e.target.value });
    }
    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        if (!p.items) return null;
        const selected = p.items.find(x => x.id == p.value);
        const rowClass = (p.inline) ? (p.rowClass || "row") : null;
        const colClass = (p.inline) ? (p.colClass || "col-sm-4") : null;
        return (
            <div className="form-group">
                {p.title ? <SectionHeader title={p.title} required={p.required} /> : null}
                <div className={rowClass}>
                    {(p.items || []).map(x =>
                        <div key={x.id} className={colClass}>
                            <Radio name={p.name} title={x.name} value={x.id} selected={x.id == p.value}
                                onChange={(e) => this.change(e)} info={x.info} disabled={p.disabled}/>
                        </div>
                    )}
                     {p.required && e ? <span className="validationMessage"> Select one of the options </span> : null}
                </div>
                {selected && selected.desc ? <div dangerouslySetInnerHTML={{ __html: selected.desc }} /> : null}
            </div>
        );
    }
}

RadioSection.propTypes = {
    dispatch: PropTypes.func,
    name: PropTypes.string,
    title: PropTypes.string,
    items: PropTypes.array,
    inline: PropTypes.bool, //default: false, if true: radio butto will be shown in rows with 3 columns
    rowClass: PropTypes.string,
    colClass: PropTypes.string,
};
const mapStateToProps = (state, props) => {
    return {
        value: state.form && state.form[props.name],
        error: state.form && state.form.errors && state.form.errors[props.name],
    };
};
export default connect(mapStateToProps)(RadioSection);